<style lang="scss" scoped>
.img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}


.cashier-page {
  min-height: 100vh;
  background-color: #fff;
  .header {
    padding-top: 24 * 2px;
    font-size: 34px;
    line-height: 36px;
    font-weight: 600;
    color: #2a2a30;
    display: flex;
    justify-content: center;
    align-items: center
  }

  .mount-area {
    margin-top: 33 * 2px;
    .mount-tip {
      font-size: 34px;
      line-height: 48px;
      color: #2a2a30;
      text-align: center;
    }
    .mount {
      color: #2a2a30;
      margin-top: 26px;
      display: flex;
      align-items: flex-end;
      font-weight: bolder;
      height: 57 * 2px;
      justify-content: center;
      .pre {
        font-size: 60px;
      }
      .num {
        font-size: 88px;
      }
    }
  }

  .type-area {
    margin-top: 89 * 2px;
    padding-left: 20 * 2px;
    .type-tip {
      font-size: 34px;
      line-height: 24 * 2px;
      font-weight: 500;
      color: #2a2a30;
    }
    .type-list {
      .type-item {
        height: 60 * 2px;
        display: flex;
        align-items: center;
        .icon {
          width: 32 * 2px;
          height: 32 * 2px;
          margin-right: 16 * 2px;
        }
        .name {
          flex: 1;
          color: #2a2a30;
          font-size: 14 * 2px;
          line-height: 20 * 2px;
        }
        .select {
          margin-right: 22 * 2px;
          width: 24 * 2px;
          height: 24 * 2px;
        }
      }
      
    }
  }

  .footer {
    width: 100%;
    position: fixed;
    bottom: 40 * 2px;
    height: 61 * 2px;
    background-color: #F8F8FB;
    display: flex;
    justify-content: center;
    align-items: center;
    .pay-btn {
      width: 351 * 2px;
      height: 44 * 2px;
      background-color: #2a2a30;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 36px;
      font-weight: 500;
      line-height: 25px;
    }
  }
 
}
</style>

<template>
<div class="cashier-page">
  <!-- header -->
  <div class="header">确认支付</div>

  <!-- 支付金额显示区域 -->
  <div class="mount-area">
    <div class="mount-tip">实付金额</div>
    <div class="mount">
      <div class="pre">￥</div>
      <div class="num">{{orderInfo.payMount}}</div>
    </div>
  </div>

  <!-- 支付方式选择区域 -->
  <div class="type-area">
    <div class="type-tip">选择支付方式</div>
    <div class="type-list">
      <pay-item v-if="showWxPay" :payConfig="defaultPayConfig.wxpay" :curSelect="payType" @change-type="changeType"></pay-item>
      <pay-item v-if="showAliPay" :payConfig="defaultPayConfig.alipay" :curSelect="payType" @change-type="changeType"></pay-item>

      <!-- 自定义支付方式区域 -->
      <pay-item v-for="(item, index) in customConfigList" 
        :key="index" 
        :payConfig="item"
        :curSelect="payType"
        @change-type="changeType">
      </pay-item>
    </div>
  </div>

  <!-- 底部固定支付区域 -->
  <div class="footer">
    <div class="pay-btn" @click="confirmPay">
      确认支付
    </div>
  </div>


</div>
</template>

<script>
import PayItem from './pay-item'
import { checkWeChatBrowser, dealJSBridgeEvent } from './../utils/utils'
import { fetchPay } from '../../../common/api/purchase'
import { fetchCashierDetail, fetchOpenId, payOnWxBrowser, commonBrowserRequest, wxBrowserRequest } from '../../../common/api/pay-h5'
import { SPLIT_H5_PAGES } from '../../../common/constant'
import { Toast } from 'vant'
import { HOST_ADDRESS } from '../../../common/constant'
import { MessageBox } from 'mint-ui';

const PAY_TYPE = {
  Init: 0,
  WechatMiniProgram: 1,
  WechatPay: 2,
  AliPay: 3
}

export default {
  components: {
    PayItem
  },
  props: {
    showWxPay: {
      default: true
    },
    showAliPay: {
      default: () => true
    },
    curSelect: {
      default: () => 'wxpay'
    },
    customPay: {  // 是否全部开启自定义支付的提交（即不使用通用的微信和支付宝支付功能）
      default: () => false
    },
    customConfigList: {
      default: () => []
    },
    orderInfo: {
      default: () => {}
    }
  },
  data() {
    return {
      defaultPayConfig: {
        wxpay: {
          icon: 'https://oss.turingsenseai.com/1630486379349397562.png',
          name: '微信支付',
          type: 'wxpay',
          payType: PAY_TYPE.WechatPay,
        },
        alipay: {
          icon: 'https://oss.turingsenseai.com/1630905415194145366.png',
          name: '支付宝',
          type: 'alipay',
          payType: PAY_TYPE.AliPay
        },
      },
      payType: this.curSelect,
      payData: {},
      openId: ''
    }
  },

  created () {
    this.getCashierDetail()
  },
  methods: {
    getCashierDetail() {
      fetchCashierDetail({cashierId: this.orderInfo.cashierId})
      .then(res => {
        if (res && res.errorCode == 0) {
          this.payData = res
        }
      })
    },
    changeType(val) {
      console.log(val)
      this.payType = val
    },

    async confirmPay() {
      const that = this
      if (this.customPay) {
        this.$emit('custom-pay', this.payType)
      } else {
        if (this.payType == 'wxpay') {
          // 微信支付 （分为普通浏览器支付和支付宝支付）
          const isWechatBrowser = checkWeChatBrowser()
          if (isWechatBrowser) {
            if (!this.openId) {
              const { openId } = await fetchOpenId({ code: this.orderInfo.code, appId: this.orderInfo.appId })
              this.openId = openId
            }
            // MessageBox('openId', openId)
            if (!this.openId) {
              // 处理没有openId的问题
              return Toast('支付失败，请联系工作人员')
            }

            if (!this.payData.wxBrowserPayUrl) {
              return Toast('微信支付失败，请联系工作人员')
            }
            
            const wxPayOptions = await wxBrowserRequest({orderNo: this.orderInfo.orderNo, openid: this.openId, appId: this.orderInfo.appId, url: this.payData.wxBrowserPayUrl})
            wxPayOptions.appId = this.orderInfo.appId

            if (wxPayOptions && wxPayOptions.errorCode === 0) {
              dealJSBridgeEvent({
                invokeParams: wxPayOptions,
                payCallback: (that.orderInfo.resultPage) ? that.payCallBack(that.orderInfo) : undefined
              })
            }
          } else {
            this.commonPay()
          }
          
        } else if (this.payType == 'alipay') {
          // 支付宝支付
          this.commonPay()

        } else {
          this.$emit('custom-pay', this.payType)
        }
      }
    },

    commonPay() {
      const that = this

      if (!this.payData.payUrl || !this.defaultPayConfig[this.payType]) {
        return Toast('拉起支付失败，请联系工作人员')
      }
      console.log(this.defaultPayConfig[this.payType].payType)
      commonBrowserRequest({
        orderNo: this.orderInfo.orderNo,
        payType: this.defaultPayConfig[this.payType].payType,
        quitUrl: SPLIT_H5_PAGES[that.orderInfo.resultPage] ? SPLIT_H5_PAGES[that.orderInfo.resultPage]({orderNo: that.orderInfo.orderNo, result: 'fail'}) : '',  // 返回页面，由上级页面返回
        url: this.payData.payUrl
      }).then(res => {
        if (res && res.errorCode == 0) {
          window.location.href = res.payUrl
        }
      })
    },
    payCallBack(params) {
      return (res => {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          Toast('支付成功！')
          setTimeout(() => {
            window.location.href = SPLIT_H5_PAGES[params.resultPage] ? SPLIT_H5_PAGES[params.resultPage]({orderNo: params.orderNo, result: 'success'}) : ''
          }, 1000)
        } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
          Toast('取消支付！')
          setTimeout(() => {
            window.location.href = SPLIT_H5_PAGES[params.resultPage] ? SPLIT_H5_PAGES[params.resultPage]({orderNo: params.orderNo, result: 'fail'}) : ''
          }, 1000)
        } else {
          Toast('支付失败！')
          setTimeout(() => {
            window.location.href = SPLIT_H5_PAGES[params.resultPage] ? SPLIT_H5_PAGES[params.resultPage]({orderNo: params.orderNo, result: 'fail'}) : ''
          }, 1000)
        }
      })

    }
  }
}
</script>
